import { NavLink } from "react-router-dom";
import { LayoutDashboard, Settings, Building2, Users, UserCircle, ShieldCheck, FileCheck, FileText, Paperclip, Route, Network, FileUp } from "lucide-react";

const linkBase =
  "flex items-center gap-2 px-3 py-2 rounded-md text-[14px] transition-colors";
const linkInactive = "text-slate-600 hover:bg-slate-100 hover:text-slate-900";
const linkActive = "bg-primary/10 text-primary font-medium";

const NAV = [
  { to: "/dashboard", testid: "nav-dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/frameworks", testid: "nav-frameworks", icon: ShieldCheck, label: "Frameworks" },
  { to: "/soa?framework=iso27001", testid: "nav-soa", icon: FileCheck, label: "SoA" },
  { to: "/documents", testid: "nav-documents", icon: FileText, label: "Documentos" },
  { to: "/importar", testid: "nav-importar", icon: FileUp, label: "Importar" },
  { to: "/evidences", testid: "nav-evidences", icon: Paperclip, label: "Evidencias" },
  { to: "/ruta", testid: "nav-ruta", icon: Route, label: "Ruta" },
  { to: "/mapa", testid: "nav-mapa", icon: Network, label: "Mapa SGSI" },
];

const SETTINGS_NAV = [
  { to: "/settings/organization", testid: "nav-settings-organization", icon: Building2, label: "Organización" },
  { to: "/settings/users", testid: "nav-settings-users", icon: Users, label: "Usuarios" },
  { to: "/settings/profile", testid: "nav-settings-profile", icon: UserCircle, label: "Mi perfil" },
];

function Item({ to, testid, icon: Icon, label }) {
  return (
    <NavLink
      to={to}
      data-testid={testid}
      className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </NavLink>
  );
}

export default function Sidebar() {
  return (
    <aside
      data-testid="sidebar"
      className="fixed left-0 top-0 bottom-0 w-[180px] border-r border-slate-200 bg-white flex flex-col"
    >
      <div className="h-14 flex items-center px-4 border-b border-slate-200">
        <span className="font-semibold text-[16px] tracking-tight text-slate-900">Nimbus</span>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {NAV.map((n) => <Item key={n.to} {...n} />)}

        <div className="pt-4 pb-1 px-3 text-[12px] uppercase tracking-wide text-slate-400 flex items-center gap-1">
          <Settings className="h-3 w-3" /> Configuración
        </div>

        {SETTINGS_NAV.map((n) => <Item key={n.to} {...n} />)}
      </nav>
      <div className="p-3 text-[12px] text-slate-400 border-t border-slate-200">
        v0.1.0 · Iter 4
      </div>
    </aside>
  );
}
